import React from "react";
import { connect } from "react-redux";
import { mapsSelectors } from "../../../../../state/ui/shared/maps";
import { MapStyleProperties } from "utils/mapbox/mapStyleProperties";
import DynamicSliderComponent from "../DynamicSliderComponent";
import { subscriptionSelectors } from "state/subscription";
import { Tier } from "types/Tier";
import layerHelper from "utils/mapbox/layerHelper";

const FIELD_TO_LABEL_YEAR = {
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2013]: "2013",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2014]: "2014",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2015]: "2015",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2016]: "2016",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2017]: "2017",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2018]: "2018",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2019]: "2019",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2020]: "2020",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2021]: "2021",
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2022]: "2022",
};

const SELECTED_TO_DEFAULT_YEAR = {
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2013]: 2013,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2014]: 2014,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2015]: 2015,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2016]: 2016,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2017]: 2017,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2018]: 2018,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2019]: 2019,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2020]: 2020,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2021]: 2021,
  [MapStyleProperties.RawDynamicLayersFieldId.EmploymentPerPopRatio2022]: 2022,
};

const mapStateToProps = (state) => ({
  tier: subscriptionSelectors.getTier(state),
  getSelectedDynamicLayer: mapsSelectors.getSelectedDynamicLayerGroup(state),
  dynamicLayerConfigurations: mapsSelectors.getDynamicLayerConfigurations(state),
  getSelectedDynamicLayerSet: mapsSelectors.getSelectedDynamicLayerSet(state),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

export class EmploymentPerPopulationDynamicLayerSlider extends React.PureComponent<Props, {}> {
  render() {
    const { getSelectedDynamicLayerSet, getSelectedDynamicLayer, tier, dynamicLayerConfigurations } = this.props;
    if (!getSelectedDynamicLayer || !getSelectedDynamicLayerSet) return null;

    const layerSelected = getSelectedDynamicLayerSet[getSelectedDynamicLayer];
    if (!layerSelected) return null;

    const isEmploymentPerPopulationDynamicLayer =
      getSelectedDynamicLayer === MapStyleProperties.DynamicLayerId.Dynamic_Layer_Employment_Per_Population;
    const isDemo = tier === Tier.None;
    const hasData = layerHelper.areLayersAvailableInGroup(dynamicLayerConfigurations, getSelectedDynamicLayer);
    const renderComponent = isEmploymentPerPopulationDynamicLayer && !isDemo && hasData;

    return (
      <>
        {renderComponent && (
          <DynamicSliderComponent
            currentLabel={FIELD_TO_LABEL_YEAR[layerSelected]}
            sliderMin={2013}
            sliderMax={2022}
            defaultValue={SELECTED_TO_DEFAULT_YEAR[layerSelected]}
          />
        )}
      </>
    );
  }
}

export default connect(mapStateToProps)(EmploymentPerPopulationDynamicLayerSlider);
